import cn from 'classnames';

import Text from 'components/BaseHelpers/Text';

import styles from './ResultsSummary.module.scss';

export type ResultsSummaryProps = {
  header: string;
  options: Array<{ label: string; onClick: () => void; disabled: boolean; selected: boolean }>;
};

const ResultsSummary = (props: ResultsSummaryProps): JSX.Element => {
  const { header, options } = props;
  return (
    <div className={styles.main}>
      <Text className={cn('body-eyebrow', styles.header)} field={header} />
      <div className={styles.options}>
        {options.map((option, index) => (
          <button
            key={index}
            className={cn(styles.button, 'body-eyebrow', {
              [styles['not-selected']]: !option.selected,
              [styles.selected]: option.selected,
            })}
            onClick={option.onClick}
            disabled={option.disabled}
            type="button"
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ResultsSummary;
